module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/resort/spot_sp-219ce776141fa00038d9021d806a5169.png";